import React, { useEffect } from 'react';
import { getScrollbarSize } from '@xarvio/frontend-core-platform/lib/utils/getScrollbarSize';
import { useDispatch } from 'react-redux';
import { uiSlice } from '../../../redux/modules/ui/uiSlice';

export const UIMeasure: React.FC<React.PropsWithChildren<unknown>> = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const { width: scrollbarWidth } = getScrollbarSize();

    dispatch(uiSlice.actions.setScrollbarWidth(scrollbarWidth));
  }, [dispatch]);

  return null;
};
